<template>
    <div id="dateDialog">
        <slot name="myHeader"></slot>
        <el-row
            class="row-flex"
            :class="{rowMar:type=='normal'}"
            :inline="dialogForm.inline"
            :model="formValue"
            :rules="rules"
            :gutter="gutter"
        >
            <template v-for="(item,index) in dialogForm.inputList">
                <el-col
                    v-if="!item.hidden"
                    :key="index"
                    :prop="item.value"
                    :span="item.span"
                >
                    <template v-if="item.type === 'custom'">
                        <slot name="customFormCol" v-bind="{ ...item }"></slot>
                    </template>
                    <template v-else>
                        <el-col
                            :span="item.labelWidth || dialogForm.labelWidth"
                            :class="{rowMar:type=='date','txtRgt':dialogForm.labelEnd}"
                            :style="{width: item.leftWidth}"
                        >
                            <span v-if="!item.isHideShow || (item.isHideShow && item.isShow)" class="label" :class="{mustFillLabel:item.mustFill}">{{item.label}}</span>
                        </el-col>
                        <el-col :span="item.inputWidth || dialogForm.inputWidth" :class="{rowMar:type=='date'}" :style="{width: item.rightWidth}">
                            <el-input
                                :placeholder="item.placeholder ? item.placeholder : '请输入' + item.label"
                                v-model.trim="formValue[item.value]"
                                v-if="item.type==='text' && (!item.isHideShow || (item.isHideShow && item.isShow))"
                                :maxlength="item.maxlength || ''"
                                :readonly="item.readOnly"
                                :show-word-limit="item.showLimit"
                                :type="item.inputType"
                                clearable
                                :autofocus="item.autofocus"
                                :disabled="getDisabledStatus(item)"
                                :class="{mustFill: item.mustFill&&!formValue[item.value]&&showMustFill}"
                                @input="dialogCheck(formValue[item.value],item)"
                                @blur="dialogBlur(formValue[item.value],item)"
                            >
                                <el-button
                                    slot="append"
                                    icon="el-icon-search"
                                    v-if="item.endIcon"
                                    @click="search"
                                ></el-button>
                            </el-input>
                            <el-input-number v-if="item.type==='number' && (!item.isHideShow || (item.isHideShow && item.isShow))"
                                :class="{mustFill: item.mustFill&&!formValue[item.value]&&showMustFill}"
                                :placeholder="item.placeholder ? item.placeholder : '请输入' + item.label"
                                v-model="formValue[item.value]"
                                :controls-position="item.controlsPosition"
                                :step="item.step||1"
                                :step-strictly="item.stepStrictly||false"
                                :precision="item.precision"
                                :size="item.size"
                                :disabled="item.disabled"
                                :controls="item.controls"
                                :min="item.min"
                                :max="item.max"
                                @input="dialogCheck(formValue[item.value],item)"
                                @blur="dialogBlur(formValue[item.value],item)"/>
                            <el-input
                                :placeholder="item.placeholder ? item.placeholder : '请输入' + item.label"
                                v-model.trim="formValue[item.value]"
                                v-if="item.type==='readonlyText'"
                                :readonly="item.readOnly"
                                :disabled="item.disabled"
                                :class="{mustFill:item.mustFill&&!formValue[item.value]&&showMustFill}"
                                @input="dialogCheck(formValue[item.value],item)"
                                @focus="$event.target.blur()"
                                clearable
                            >
                                <el-button
                                    slot="append"
                                    icon="el-icon-search"
                                    v-if="item.endIcon"
                                    @click="search"
                                ></el-button>
                            </el-input>
                            <el-input
                                v-model="formValue[item.value]"
                                v-else-if="item.type==='textarea' && (!item.isHideShow || (item.isHideShow && item.isShow))"
                                type="textarea"
                                resize="none"
                                :readonly="item.readOnly"
                                :disabled="getDisabledStatus(item)"
                                :autosize="item.autosize || { minRows: 2, maxRows: 6 }"
                                :show-word-limit="item.showLimit || false"
                                :maxlength="item.maxlength || ''"
                                :minlength="item.minlength || ''"
                                :placeholder="item.placeholder ? item.placeholder : '请输入' + item.label"
                                :class="{mustFill: item.mustFill&&!formValue[item.value]&&showMustFill}"
                                @input="dialogCheck(formValue[item.value],item)"
                                @blur="dialogBlur(formValue[item.value],item)" >
                            </el-input>
                            <el-select
                                :placeholder="item.placeholder ? item.placeholder : '请选择'+item.label"
                                :class="{mustFill:item.mustFill&&!formValue[item.value]&&showMustFill}"
                                v-else-if="item.type==='select'"
                                v-model="formValue[item.value]"
                                style="width:100%;"
                                :collapse-tags="item.collapseTags || false"
                                :filterable="item.filterable || false"
                                :multiple="item.multiple || false"
                                :disabled="item.readOnly||getDisabledStatus(item)"
                                :clearable="true"
                                @change="dialogCheck(formValue[item.value],item)"
                            >
                                <el-option
                                    v-for="(option,index) in item.options"
                                    :key="index"
                                    :label="option.label"
                                    :value="option.value"
                                    :disabled="option.disabled || false"
                                ></el-option>
                            </el-select>
                            <el-checkbox v-else-if="item.type==='checkbox'" v-model="formValue[item.value]" :disabled="item.readOnly"
                                @change="switchChange($event, item)">
                            </el-checkbox>
                            <el-switch
                                v-else-if="item.type==='switch'"
                                v-model="formValue[item.value]"
                                :active-text="item.activeText || '启用'"
                                :inactive-text="item.inactiveText || '停用'"
                                :active-value="item.activeValue || true"
                                :inactive-value="item.inactiveValue || false"
                                :disabled="item.readOnly||getDisabledStatus(item)"
                                @change="switchChange($event, item)"></el-switch>
                            <el-date-picker
                                v-else-if="item.type==='datePicker'"
                                :type="item.key"
                                :disabled="item.readOnly"
                                :placeholder="item.label"
                                :picker-options="item.pickerOptions || {}"
                                :start-placeholder="item.startPlaceholder"
                                :class="{mustFill:item.mustFill&&!formValue[item.value]&&showMustFill}"
                                :end-placeholder="item.endPlaceholder"
                                v-model="formValue[item.value]"
                                @change="dialogCheck(formValue[item.value],item)"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            ></el-date-picker>
                            <el-cascader
                                v-else-if="item.type==='cascader'"
                                :options="item.options"
                                :disabled="item.readOnly"
                                :class="{mustFill:item.mustFill&&!formValue[item.value]&&showMustFill}"
                                v-model="formValue[item.value]"
                                @change="dialogCheck(formValue[item.value],item)"
                                :placeholder="item.label"
                            ></el-cascader>
                            <otpAdvance
                                v-else-if="item.type==='advance'"
                                :params="item"
                                :disabled="item.readOnly"
                                @getAdvanceValue="getAdvanceValue($event, item)"
                                :mValue="formValue[item.value]"
                                :formData="formValue"
                                :class="{mustFill:item.mustFill&&!formValue[item.value]&&showMustFill}"
                                class="advance-box"
                            ></otpAdvance>
                            <otpSelect
                                v-else-if="item.type==='dictionary'"
                                :key="item.value"
                                :disabled="item.readOnly||getDisabledStatus(item)"
                                :mValue="formValue[item.value]"
                                :optionNum="item.optionNum"
                                :optionArr="item.options"
                                :class="{mustFill:item.mustFill&&!formValue[item.value]&&showMustFill}"
                                :prop="item.value"
                                @change="dialogCheck(formValue[item.value],item)"
                                :disabledOptions="item.disabledOptions || []"
                                :multiple="item.multiple || false"
                                :selectAll="item.selectAll"
                                :collapseTags="item.collapseTags"
                                :placeholder="item.placeholder ? item.placeholder : '请选择' + item.label"
                                @getSelectValue="getSelectValue"
                            ></otpSelect>
                            <!-- <otpAllAddressSelect
                                :disabled="item.readOnly"
                                v-else-if="item.type==='addressSelect'"
                                :class="{mustFill:item.mustFill&&!formValue[item.value]&&showMustFill}"
                                :mValue="formValue[item.value]"
                                :prop="item.value"
                                :minLayers="item.minLayers"
                                :labelName="item.labelCn"
                                @getAddress="getAddress"
                            ></otpAllAddressSelect> -->
                            <otpAllAddressCascader
                                :disabled="item.readOnly"
                                v-else-if="item.type==='addressCascader'"
                                :class="{mustFill:item.mustFill&&!(formValue[item.value]&&formValue[item.value].length)&&showMustFill}"
                                v-model="formValue[item.value]"
                                :basicProps="item.config"
                                :minLayers="item.minLayers"
                                :placeholder="item.placeholder ? item.placeholder : '请选择' + item.label"
                                @getAddress="getAddress($event, item.prop)"
                            ></otpAllAddressCascader>
                            <el-radio-group v-model="formValue[item.value]" v-else-if="item.type==='radio'" @change="dialogCheck(formValue[item.value],item)">
                                <el-radio
                                    v-for="(item,index) in item.options"
                                    :key="index"
                                    :disabled="item.disabled || false"
                                    :label="item.value">
                                    {{item.label}}
                                </el-radio>
                            </el-radio-group>
                            <el-time-picker
                                v-else-if="item.type==='timePicker'"
                                :disabled="item.disabled"
                                v-model="formValue[item.value]"
                                :class="{mustFill:item.mustFill&&!formValue[item.value]&&showMustFill}"
                                :picker-options="{selectableRange: '00:00:00 - 23:59:59'}"
                                @change="dialogCheck(formValue[item.value], item)"
                                :placeholder="item.placeholder ? item.placeholder : '请选择' + item.label">
                            </el-time-picker>

                            <el-autocomplete
                                v-else-if="item.type==='autocomplete' && item.autoConfig"
                                v-model="formValue[item.value]"
                                :class="{
                                    'autocomplete-box': true,
                                    mustFill:item.mustFill&&!formValue[item.value]&&showMustFill
                                }"
                                clearable
                                :placeholder="item.placeholder ? item.placeholder : '请输入' + item.label"
                                :disabled="item.disabled"
                                :fetch-suggestions="(keywords, cb) => searchAutocomplete(keywords, cb, item)"
                                :trigger-on-focus="false"
                                onKeypress="javascript:if(event.keyCode === 32) event.returnValue = false;"
                                @select="autocompleteSelect($event, item)"
                                @change="autocompleteChange($event, item)"
                            >
                                <!-- 自定义html -->
                                <template v-if="item.autoConfig.html" v-slot="scope">
                                    <div v-html="item.autoConfig.html(scope)" class="autocomplete-content"></div>
                                </template>
                                <template v-else v-slot="scope">
                                    <div :title="scope.item.address" class="addr">{{ scope.item.address }}</div>
                                </template>
                            </el-autocomplete>
                            <template v-else-if="item.type === 'customInput'">
                                <slot name="customFormColInput" v-bind="{ ...item }"></slot>
                            </template>
                        </el-col>
                    </template>
                </el-col>
            </template>
            <el-col class="btnList" :span="dialogForm.btnSpan">
                <el-button
                    v-for="item in dialogForm.actBtn"
                    :key="item"
                    type="primary"
                    @click="dialogCheck(formValue[item.value],item)"
                >{{item}}</el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import otpSelect from '@/components/lots/otpSelect';
import otpAdvance from '@/components/lots/otpAdvance';
// import otpAllAddressSelect from '@/components/lots/otpAllAddressSelect';
import otpAllAddressCascader from '@/components/lots/addressCascader';
export default {
    data() {
        return {
            formValue: {},
            rules: {},
            showMustFill: false
        };
    },
    created() {
        this.formValue = { ...this.formValue, ...this.mFormValue };
        this.formInit(true);
    },
    props: {
        dialogForm: Object,
        gutter: [Number, String],
        type: String,
        mFormValue: Object
    },
    watch: {
        mFormValue(val) {
            this.formValue = val;
            this.formInit();
        }
    },
    components: { otpSelect, otpAdvance, otpAllAddressCascader },
    methods: {
        getDisabledStatus(item) {
            if (typeof item.disabled === 'function') {
                return item.disabled(this.formValue, item);
            }
            return item.disabled || false;
        },
        searchAutocomplete(keywords, cb, col) {
            this.$emit('handleFetchSuggestions', keywords, cb, col);
        },
        autocompleteSelect(data, col) {
            this.autocompleteChange(data.value, col);
            // 单独处理select回传的数据
            this.$emit('handleAutocompleteSelect', data, col);
        },
        autocompleteChange(val, col) {
            this.dialogCheck(val, col);
        },
        search() {
            this.$emit('search', 123);
        },
        classification(item, statusKey, status, key, arr, logic) {
            const flagArr = [];
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].indexOf('!=') !== -1) {
                    const val = arr[i].split('!=')[1];
                    if (!logic || logic !== '&&') {
                        if (val !== this.formValue[key]) {
                            item[status] = true;
                            return item;
                        }
                    } else {
                        if (val === this.formValue[key]) {
                            flagArr.push(false);
                        } else {
                            flagArr.push(true);
                        }
                    }
                } else {
                    if (!logic || logic !== '&&') {
                        if (arr[i] === this.formValue[key]) {
                            item[status] = true;
                            return item;
                        }
                    } else {
                        if (arr[i] !== this.formValue[key]) {
                            flagArr.push(false);
                        } else {
                            flagArr.push(true);
                        }
                    }
                }
            }
            let flag = false;
            flagArr.forEach((item, index) => {
                if (index === 0) {
                    flag = item;
                } else {
                    flag = flag || item;
                }
            });
            item[status] = flag;
            return item;
        },
        mulcon(item, statusKey, status, key, logic) {
            if (item[statusKey][key].indexOf('|') !== -1) {
                const arr = item[statusKey][key].split('|');
                item = this.classification(item, statusKey, status, key, arr, logic);
                if (logic && logic === '&&') {
                    if (!item[status]) {
                        return item;
                    }
                } else {
                    if (item[status]) {
                        return item;
                    }
                }
            } else {
                item = this.classification(item, statusKey, status, key, [item[statusKey][key]], logic);
                if (logic && logic === '&&') {
                    if (!item[status]) {
                        return item;
                    }
                } else {
                    if (item[status]) {
                        return item;
                    }
                }
            }
            return item;
        },
        changeState(item, statusKey, status) {
            const flagArr = [];
            if (item[statusKey]) {
                for (const key in item[statusKey]) {
                    if (item[statusKey].hasOwnProperty(key)) {
                        if (key !== 'logic') {
                            item = this.mulcon(item, statusKey, status, key, item[statusKey].logic);
                            if (item[statusKey].logic && item[statusKey].logic === '&&') {
                                if (!item[status]) {
                                    flagArr.push(false);
                                } else {
                                    flagArr.push(true);
                                }
                            } else {
                                if (item[status]) {
                                    return item;
                                }
                            }
                        }
                    }
                }
            }
            if (item[statusKey] && item[statusKey].logic && item[statusKey].logic === '&&') {
                let flag = false;
                if (flagArr.length) {
                    flagArr.forEach((item, index) => {
                        if (index === 0) {
                            flag = item;
                        } else {
                            flag = flag && item;
                        }
                    });
                }
                item[status] = flag;
                return item;
            }
            return item;
        },
        changeShowMustFill() {
            let flag = false;
            this.dialogForm.inputList.forEach(item => {
                item = this.changeState(item, 'isShowRelyOn', 'isShow');
                if (item.isHideShow) {
                    if (!item.isShow) {
                        this.formValue[item.value] = null;
                        item.mustFill = false;
                    } else {
                        item.mustFill = item.defaultFill;
                    }
                }
                item = this.changeState(item, 'mustFillRelyOn', 'mustFill');
                if (item.mustFill && !item.hidden && item.type !== 'number') {
                    if (!this.formValue[item.value] || (!this.formValue[item.value].length && Object.prototype.toString.call(this.formValue[item.value]) !== '[object Date]')) {
                        flag = true;
                    }
                }
                if (item.mustFill && !item.hidden && item.type === 'number') {
                    flag = !this.formValue[item.value];
                }
                item = this.changeState(item, 'disabledRelyOn', 'readOnly', !item.hidden);
                if (item.valueDependentOnDisabled && item.valueDependentOnDisabled.val && item.readOnly) {
                    this.formValue[item.value] = item.valueDependentOnDisabled.setValue;
                }
            });
            return flag;
        },
        GetDateT(d) {
            var s;
            s = d.getYear() + 1900 + '-';
            s = s + (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + '-';
            s += d.getDate() < 10 ? '0' + d.getDate() : d.getDate() + '';
            return s;
        },
        dialogBlur(val, col) {
            this.$emit('dialogBlur', this.formValue, col);
        },
        dialogCheck(val, col) {
            // 返回form的值
            if (col && col.relyOn) {
                col.relyOn.forEach(item => {
                    if (item.value === 'now') {
                        this.formValue[item.field] = new Date();
                    } else {
                        if (item.value === 'date') {
                            this.formValue[item.field] = this.GetDateT(new Date());
                        } else {
                            this.formValue[item.field] = item.value;
                        }
                    }
                });
            }
            if (col && col.relyOnVlaue) {
                col.relyOnVlaue.forEach(item => {
                    if (val === item.value && this.formValue[item.field] === item.targetValue) {
                        this.formValue[item.field] = item.setValue;
                    }
                });
            }
            if (col && col.changeInputType) {
                col.changeInputType.forEach(item => {
                    this.dialogForm.inputList.forEach(son => {
                        if (son.value === item.field) {
                            for (const key in item.type) {
                                if (item.type.hasOwnProperty(key) && val === item.type[key]) {
                                    son.type = key;
                                }
                            }
                        }
                    });
                });
            }
            this.changeShowMustFill();
            this.$emit('dialogCheck', this.formValue, col);
        },
        formInit(created) {
            this.dialogForm.inputList.forEach((item, index) => {
                if (!this.formValue[item.value] && this.formValue[item.value] !== 0 && item.defaultValue) {
                    this.formValue[item.value] = item.defaultValue;
                }

                // rulesInit
                if (created) {
                    if (item.rules && item.rules.required) {
                        this.rules[item.value] = [];
                        this.rules[item.value].push(item.rules);
                    }
                }
            });
            this.changeShowMustFill();
        },
        getSelectValue(data, label) {
            this.formValue = { ...this.formValue, ...data };
        },
        getAdvanceValue(data, item) {
            this.formValue = { ...this.formValue, ...data };
            this.dialogCheck(data, item);
            this.$emit('getAdvanceValue', { data, item });
        },
        getAddress(labels, prop) {
            this.dialogCheck();
            if (labels) {
                this.$emit('getAddressLabels', labels, prop);
            }
        },
        switchChange(value, col) {
            this.$set(this.mFormValue, col.value, value);
            this.dialogCheck(value, col);
        }
    }
};
</script>

<style lang="less">
#dateDialog {
    padding: 0 16px;
    .mustFill{
        .el-input__inner{
            border:1px solid red;
        }
        .el-textarea__inner{
            border:1px solid red;
        }
    }
    .mustFillLabel{
        &:before{
            content:'* ';
            color:red;
        }
    }
    .el-row {
        padding: 0 0 10px;
        .el-col {
            display: flex;
            align-items: center;
            margin-bottom: 10px !important;
            .el-icon-date,
            .el-range-separator,
            .el-range__close-icon {
                display: flex;
                align-items: center;
            }
            .el-col {
                padding: 0 !important;
                margin-top: 0 !important;
            }
        }
        .btnList {
            display: flex;
            justify-content: flex-end;
            .el-button {
                margin-left: 10px;
            }
        }
        .rowMar {
            margin-bottom: 16px;
        }
        .rowPad {
            padding: 0 20px 10px;
        }
    }
    .txtRgt {
        display: flex;
        justify-content: flex-end;
        span {
            padding-right: 10px;
        }
    }
    .row-flex {
        display: flex;
        flex-wrap: wrap;
    }
    .m-address-cascader {
        width: 100%;
    }
    .el-autocomplete {
        width: 100%;
    }
}
.autocomplete-box {
    .el-autocomplete-suggestion__list {
        .addr {
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }
}
</style>
